module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/gift-4f880858648988eed7ea29afe32b4d0c.png";